(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ves-announcement"] && !Shopify.designMode) return;
  try {
    
  class VesAnnounce {
    constructor(root) {
      this.items = Array.from(root.querySelectorAll('[data-announce-item]'));
      if (this.items.length < 2) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.index = 0;
      this.speed = parseInt(root.dataset.speed, 10) || 5000;
      this.timer = null;
      this.userPaused = false;
      this.pauseBtn = root.querySelector('[data-pause]');

      if (this.pauseBtn) {
        this.pauseBtn.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.pauseBtn.setAttribute('aria-pressed', String(this.userPaused));
          if (this.userPaused) this.stop();
          else this.start();
        });
      }

      // Una barra que sigue rotando en una pestaña oculta gasta sin que nadie
      // la lea, y al volver muestra un mensaje que el usuario nunca vio partir.
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.start();
      });

      this.start();
    }

    next() {
      this.items[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.items.length;
      this.items[this.index].classList.add('is-active');
    }

    start() {
      if (this.timer || this.userPaused) return;
      this.timer = setInterval(() => this.next(), this.speed);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  function initVesAnnounce() {
    document.querySelectorAll('[data-ves-announce]').forEach((el) => {
      if (el.dataset.vesInit === 'true') return;
      el.dataset.vesInit = 'true';
      new VesAnnounce(el);
    });
  }

  document.addEventListener('DOMContentLoaded', initVesAnnounce);
  document.addEventListener('shopify:section:load', initVesAnnounce);

  } catch(e) { console.error(e); }
})();
})();
